var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.summaryBackgroundColor },
    _vm._l(_vm.property.values, function(sub_property, sub_index) {
      return _c(
        "div",
        {
          key: "sub-property-label-" + sub_index,
          staticClass: "d-flex justify-space-between"
        },
        [
          sub_index === 0
            ? [
                _c(
                  "h4",
                  { class: _vm.labelClass },
                  [
                    !_vm.noLabel
                      ? _vm._t("label", [
                          _vm.property.label !== ""
                            ? [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.property.label) +
                                    "\n                        "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getSubPropertyLabel(sub_property)
                                    ) +
                                    "\n                        "
                                )
                              ]
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ]
            : [
                _c(
                  "h4",
                  { class: _vm.subLabelClass },
                  [
                    _vm.showSecondaryLabels
                      ? [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getSubPropertyLabel(sub_property)) +
                              "\n                    "
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ],
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex justify-end align-center",
              staticStyle: { width: "150px" }
            },
            [
              _c(
                "p",
                {
                  staticClass: "mr-1 mb-0",
                  class: _vm.textClass(sub_index, sub_property)
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.getSubPropertyValue(sub_property)) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.getSubPropertyDescription(sub_property)
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-icon",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          color: _vm.infoIconColor,
                                          small: ""
                                        }
                                      },
                                      "v-icon",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      "\n                            $mdiInformation\n                        "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.getSubPropertyDescription(sub_property)
                          )
                        }
                      })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }